import { lazy } from "react";
import ProtectedRoute from "../guards/ProtectedRoute";

const MainLayout = lazy(() => import("../../layouts/MainLayout/MainLayout"));

const SettingsLandingPage = lazy(() =>
  import("../../Modules/Configurations/Index/Page/SettingsLandingPage")
);
const ProfilePage = lazy(() =>
  import("../../Modules/Configurations/Profile/Page/ProfilePage")
);
const RegionalPage = lazy(() =>
  import("../../Modules/Configurations/Regional/Page/RegionalPage")
);
const NotificationsPage = lazy(() =>
  import("../../Modules/Configurations/Notifications/Page/NotificationsPage")
);
const PrivacyPage = lazy(() =>
  import("../../Modules/Configurations/Privacy/Page/PrivacyPage")
);
const SecurityPage = lazy(() =>
  import("../../Modules/Configurations/Security/Page/SecurityPage")
);
const AccountSettings = lazy(() =>
  import(
    "../../Modules/Configurations/AccountAdvanceSetting/Components/AccountSetting"
  )
);
const AdvanceConfiguration = lazy(() =>
  import(
    "../../Modules/Configurations/AccountAdvanceSetting/Components/AdvanceConfiguration"
  )
);
const CategorizationPage = lazy(() =>
  import("../../Modules/Configurations/Categories/Page/CategorizationPage")
);
const GroupsPage = lazy(() =>
  import("../../Modules/Configurations/Groups/Page/GroupsPage")
);
const WorkspacePage = lazy(() =>
  import("../../Modules/Configurations/Workspace/Page/WorkspacePage")
);
const AuditTrailPage = lazy(() =>
  import("../../Modules/Configurations/AuditTrail/Page/AuditTrailPage")
);
const ThemePage = lazy(() =>
  import("../../Modules/Configurations/Theme/Page/ThemePage")
);
const CalendarPage = lazy(() =>
  import("../../Modules/Configurations/Calendar/Page/CalendarPage")
);
const SetupPage = lazy(() =>
  import("../../Modules/Configurations/Setup/Page/SetupPage")
);

// ProtectedRoute on the layout element guards every child automatically.
const configRoutes = {
  path: "configuration",
  element: (
    <ProtectedRoute>
      <MainLayout identifier="CONFIG" />
    </ProtectedRoute>
  ),
  children: [
    { index: true,                   element: <SettingsLandingPage /> },

    // ── My account ───────────────────────────────────────────────────
    { path: "profile",               element: <ProfilePage /> },
    { path: "regional",              element: <RegionalPage /> },
    { path: "notifications",         element: <NotificationsPage /> },
    { path: "theme",                 element: <ThemePage /> },
    { path: "privacy",               element: <PrivacyPage /> },
    { path: "security",              element: <SecurityPage /> },

    // ── Workspace ────────────────────────────────────────────────────
    { path: "workspace",             element: <WorkspacePage /> },
    { path: "groups",                element: <GroupsPage /> },
    { path: "categories",            element: <CategorizationPage /> },
    { path: "calendar",              element: <CalendarPage /> },
    { path: "audit-trail",           element: <AuditTrailPage /> },
    { path: "setup",                 element: <SetupPage /> },

    // ── Legacy routes (kept for back-compat with existing menus & deep links)
    { path: "account-settings",      element: <AccountSettings /> },
    { path: "advance-configuration", element: <AdvanceConfiguration /> },
  ],
};

export default configRoutes;
